import { render, staticRenderFns } from "./addMajor.vue?vue&type=template&id=eedfbb6c&scoped=true&"
import script from "./addMajor.vue?vue&type=script&lang=js&"
export * from "./addMajor.vue?vue&type=script&lang=js&"
import style0 from "./addMajor.vue?vue&type=style&index=0&id=eedfbb6c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eedfbb6c",
  null
  
)

export default component.exports